const videoWraps = document.getElementsByClassName('General--Video')

function isVideoPlaying(video) {
    return (
        video.currentTime > 0 &&
        !video.paused &&
        !video.ended &&
        video.readyState >= 2
    )
}

const onFullscreenExit = (videoElement, playButton) => {
    videoElement.pause()
    videoElement.classList.remove('Playing')
    playButton.classList.remove('NoAnimation')

    if (videoElement.duration - videoElement.currentTime > 6) {
        videoElement.classList.add('Paused')
    } else {
        videoElement.currentTime = 0
    }
}

for (let videoWrap of videoWraps) {
    const videoElement = videoWrap.querySelector('video')
    const playButton = videoWrap.querySelector('.Play')
    if (videoElement) {
        videoWrap.addEventListener('click', () => {
            if (!isVideoPlaying(videoElement)) {
                videoElement.classList.remove('Paused')
                playButton.classList.add('NoAnimation')
                videoElement.classList.add('Playing')

                if (!document.fullscreenElement && videoElement.requestFullscreen) {
                    videoElement.requestFullscreen()
                    videoElement.play()
                } else if (!document.webkitFullscreenElement && videoElement.webkitRequestFullscreen) {
                    videoElement.webkitRequestFullscreen() // Safari
                    videoElement.play()
                } else if (!document.msFullscreenElement && videoElement.msRequestFullscreen) {
                    videoElement.msRequestFullscreen() // IE11
                    videoElement.play()
                } else {
                    videoElement.controls = true
                    videoElement.removeAttribute('playsinline')
                    videoElement.play()
                }
            }
        }, {passive: true})

        videoElement.addEventListener('pause', () => {
            videoElement.controls = false
            videoElement.setAttribute('playsinline', '')

            if (document.exitFullscreen)
                document.exitFullscreen()
            else
                onFullscreenExit(videoElement, playButton)
        })

        // Listen for fullscreen change
        document.addEventListener('fullscreenchange', () => {
            if (!document.fullscreenElement) {
                onFullscreenExit(videoElement, playButton)
            }
        })

        // Optional: Handle vendor-prefixed events for compatibility
        document.addEventListener('webkitfullscreenchange', () => {
            if (!document.webkitFullscreenElement) {
                onFullscreenExit(videoElement, playButton)
            }
        })

        document.addEventListener('msfullscreenchange', () => {
            if (!document.msFullscreenElement) {
                onFullscreenExit(videoElement, playButton)
            }
        })
    }
}
